export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-[#111827] py-4 bg-[#020617] text-[0.85rem] text-[#9ca3af]">
      <div className="max-w-[1120px] mx-auto px-4 flex flex-col items-center justify-between gap-4 md:flex-row md:items-start">
        <div className="flex flex-col gap-2 text-center md:text-left">
          <p className="m-0">© {currentYear} Tarot Virtual. Todos os direitos reservados.</p>
          <p className="m-0 text-[#64748b]">Este website utiliza inteligência artificial.</p>
        </div>
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 md:justify-end">
          <a href="/privacidade.html" className="hover:text-[#e5e7eb] transition-colors">Política de Privacidade</a>
          <a href="/cookies.html" className="hover:text-[#e5e7eb] transition-colors">Política de Cookies</a>
          <a href="/termos.html" className="hover:text-[#e5e7eb] transition-colors">Termos e Condições</a>
          <a href="https://www.livroreclamacoes.pt/" target="_blank" rel="noopener noreferrer" className="hover:text-[#e5e7eb] transition-colors">Livro de Reclamações Online</a>
          <a href="https://app.tarot-online.com.pt/consultores" rel="noopener" className="hover:text-[#e5e7eb] transition-colors">Consulta um tarólogo real ao vivo</a>
          <a href="mailto:geral@tarot-online.com.pt" className="hover:text-[#e5e7eb] transition-colors">Contactos</a>
        </div>
      </div>
    </footer>
  );
}
